import React from 'react';

import {OAuthFinishScreen} from 'features/auth';

const OAuthFinishPage: React.FC = () => {
    return <OAuthFinishScreen/>;
};

export default OAuthFinishPage;
